import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '../../../../components/elements'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../../../src/constants/images/cloudinary'
import './ownerInfo.css'
import StartConversation from './../../../conversations/components/startConversation'
// import OwnerBadge from '../../sections/ownerBadge'
// let ownerImage = require('../../../theme/assets/images/check_icon.png')es'
import { Grid } from '@mui/material'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})

// function GuideButton(props) {
//   return (
//     <div className="guide-btn-wrapper">
//       <button
//         className={'button is-fullwidth is-outlined'}
//         onClick={(e) => {
//           e.preventDefault()
//           document.getElementById('ride-recommendtion').scrollIntoView()
//         }}
//       >
//         5 Ride Guides
//       </button>
//     </div>
//   )
// }

const OwnerInfo = (props) => {
  const isMobile = props.isMobile
  const bikeData = props.bikeData

  const hideConversationContainer = () => {
    return (
      (bikeData.partner_allow_messaging === true &&
        bikeData.is_partner === true) ||
      bikeData.is_partner === false
    )
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={2} xs={2}>
          <div className="owner-avatar is-82x82">
            <Link
              to={bikeData.owner_link}
              className="owner-avatar-badge has-text-centered is-inline-block"
            >
              <Image
                src={cl.url(bikeData.bike_owner_avatar_cloudinary_public_id, {
                  gravity: 'center',
                  height: 150,
                  width: 150,
                  crop: 'fill',
                  format: 'jpg',
                  quality: 'auto'
                })}
                rounded
                className={'is-inline-block m'}
                size={isMobile ? 48 : 64}
                alt={bikeData.bike_owner_name + "'s Profile"}
              />
            </Link>
          </div>
        </Grid>
        <Grid item md={10} xs={10} sm container>
          <Grid item xs container direction="column" spacing={1}>
            <Grid item>
              <div>
                <div className="hosted-by-header">Hosted by:</div>
                <div className="owner-auth">
                  <strong className="bike-owner-name">
                    {bikeData.bike_owner_name}
                  </strong>
                  {bikeData.bike_owner_phone_verified &&
                    bikeData.bike_owner_email_verified && (
                      <span className="verified-container">
                        <i className="fas fa-circle-check"></i> Phone &#38;
                        Email Verified
                      </span>
                    )}
                </div>
                <div className="bike-owner-rating-info">
                  {bikeData.bike_owner_rating > 0 && (
                    <p className="has-black-dark-text">
                      <span className="bike-profile-bike-rating-digit">
                        {bikeData.bike_owner_rating}
                      </span>
                      &nbsp;
                      <i className="fa fa-star bike-profile-bike-rating"></i>
                    </p>
                  )}
                  {Number(bikeData.bike_owner_review_count) > 0 && (
                    <p className="has-black-dark-text review-count-hosted-section">
                      {bikeData.bike_owner_review_count}
                      {Number(bikeData.bike_owner_review_count) === 1
                        ? ' Review'
                        : ' Reviews'}
                    </p>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {hideConversationContainer() && (
        <Grid container spacing={2} className="conversation-container">
          <Grid item xs={12}>
            <div className="contact-owner-wrapper">
              <StartConversation
                recipientName={props.bikeData?.bike_owner_name}
                recipientAvatar={props.bikeData?.bike_owner_avatar}
                motorcycleUUID={props.bikeData?.bike_uuid_id}
                ownerUUID={props.bikeData?.bike_owner_uuid}
                riderUserPrettyId={props.userID}
                isAuth={props.isAuth}
                isPartner={bikeData?.is_partner}
                openLogin={props.openLogin}
                context="motorcycle"
                isMobile={props.isMobile}
                handlePhoneVerified={props.handlePhoneVerified}
              />
            </div>
          </Grid>
          {props.showResponseTime() && props.responseTime && (
            <Grid item xs={12}>
              <div className="owner-response-time">
                <h4>
                  {props.responseTime
                    ? 'Typically responds within ' + props.responseTime
                    : null}
                </h4>
              </div>
              {/* <GuideButton /> */}
            </Grid>
          )}
        </Grid>
      )}
    </>
  )
}

export default OwnerInfo
